// src/context/AuthContext.tsx
import React, { createContext, useContext, useState } from 'react';

interface Auth {
  userId: string;
  email: string;
}

interface AuthContextType {
  user: Auth | null;
  login: (userId: string, email: string) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | null>(null);

export const AuthProvider: React.FC = ({ children }) => {
  const [user, setUser] = useState<Auth | null>(
    // try to initialise from localStorage if you like
    null
  );

  const login = (userId: string, email: string) => {
    setUser({ userId, email });
    localStorage.setItem('auth', JSON.stringify({ userId, email }));
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('auth');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be inside AuthProvider');
  return ctx;
};
